import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { CodeWordCase } from '@/types/patient-api';

/**
 * Master data — Allergen Reactions dropdown options for the Add Allergy
 * form (PROD-827 chart write surfaces).
 *
 * Wire (Flutter `common_data_source_impl.dart:989`):
 *
 *   GET /api/Master/AllergenReaction
 *       → CodeWordCase[]
 *
 * Curl-verified by Andrew 2026-05-19. Static catalog — long staleTime
 * is safe; the option list doesn't change between user sessions.
 */

export function useAllergenReactions(enabled = true) {
  return useQuery({
    queryKey: ['master-allergen-reactions'],
    queryFn: ({ signal }) =>
      get<CodeWordCase[]>('/api/Master/AllergenReaction', { signal }),
    enabled,
    staleTime: 24 * 60 * 60 * 1000, // 24h — master-data catalog
  });
}
